declare var window: any;

const Accordion = {
  active: null,
  mounted(this: any) {
    this.el.querySelectorAll("[aria-expanded='true']").forEach((btn: any) => {
      window.liveSocket.execJS(btn, btn.getAttribute("data-exec-open"));
    });

    this.el.addEventListener("collapse_accordion", (e: any) => {
      const dispatcher = e.detail.dispatcher;
      const index = dispatcher.getAttribute("data-button-index");
      const expanded = dispatcher.getAttribute("aria-expanded") === "true";
      expanded ? (this.active = null) : (this.active = index);

      this.el.querySelectorAll("[data-button-index]").forEach((btn: any) => {
        const index = btn.getAttribute("data-button-index");
        const execOpen = btn.getAttribute("data-exec-open");
        const execClose = btn.getAttribute("data-exec-close");

        if (this.active == index) {
          window.liveSocket.execJS(btn, execOpen);
        } else {
          window.liveSocket.execJS(btn, execClose);
        }
      });
    });

    this.el.addEventListener("open_accordion", (e: any) => {
      const dispatcher = e.detail.dispatcher;
      const expanded = dispatcher.getAttribute("aria-expanded") === "true";
      const execOpen = dispatcher.getAttribute("data-exec-open");
      const execClose = dispatcher.getAttribute("data-exec-close");

      expanded
        ? window.liveSocket.execJS(dispatcher, execClose)
        : window.liveSocket.execJS(dispatcher, execOpen);
    });
  },
};

export default Accordion;
